require(
      "!../../node_modules/gatsby-module-loader/patch.js"
    );
    module.exports = function(cb) { return require.ensure([], function(_, error) {
        if (error) {
          console.log('bundle loading error', error)
          cb(true)
        } else {
          cb(null, function() { return require("!!../../node_modules/json-loader/index.js!./blog-women-hold-majority-in-recent-code-201-course.json") })
        }
      }, "path---blog-women-hold-majority-in-recent-code-201-course");
     }
    


//////////////////
// WEBPACK FOOTER
// ./~/gatsby-module-loader?name=path---blog-women-hold-majority-in-recent-code-201-course!./.cache/json/blog-women-hold-majority-in-recent-code-201-course.json
// module id = 1156
// module chunks = 231608221292675